import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import OptionArrows from "../../assets/OptionArrows";

// Modified, from:
// https://github.com/tidjungs/react-dropdowns-datepicker

// We need to heavily style this stuff. Check out:
// https://codepen.io/sverrirs/pen/dXJLRa
const select = {};
const optionStyle = {};
const initialOptionStyle = {};
const dayStyle = {
  margin: "0 10px"
};

const createDate = (date) => {
  if (!date) return [];
  const momentDate = moment(date);
  return [momentDate.month() + 1, momentDate.date(), momentDate.year()]
}


export default class DatePicker extends React.Component {
  constructor(props) {
    super(props);
    const {
      dayLabel,
      monthLabel,
      yearLabel,
      defaultDate,
      style,
      selectBoxClassName,
      selectBoxStyle
    } = props;

    const [selectMonth, selectDay, selectYear] = createDate(defaultDate);

    this.state = {
      day: null,
      month: null,
      year: null,
      selectDay: selectDay
        ? selectDay
        : props.mode === "TH"
        ? "วันที่"
        : dayLabel,
      selectMonth: selectMonth
        ? selectMonth
        : props.mode === "TH"
        ? "เดือน"
        : monthLabel,
      selectYear: selectYear
        ? selectYear
        : props.mode === "TH"
        ? "ปี"
        : yearLabel
    };
  }



  componentWillReceiveProps(nextProps) {
    if (nextProps.defaultDate !== this.props.defaultDate) {
      const [selectMonth, selectDay, selectYear] = createDate(nextProps.defaultDate);
      this.setState({
        selectMonth, selectDay, selectYear
      })
    }
  }

  componentWillMount() {
    let day = [],
      month = [],
      year = [];

    const pad = n => {
      return n < 10 ? "0" + n : n;
    };

    for (let i = 1; i <= 31; i++) {
      day.push(this.props.padDay ? pad(i) : i);
    }

    let monthIndex = 1;
    for (const monthName of moment.localeData().months()) {
      month.push({
        text: this.props.useMonthNames
          ? monthName
          : this.props.padMonth
          ? pad(monthIndex)
          : monthIndex,
        value: monthIndex
      });
      monthIndex++;
    }

    for (let i = this.props.maxYear; i >= this.props.minYear; i--) {
      year.push(i);
    }

    this.setState({
      day: day,
      month: month,
      year: year
    });
  }


  changeDate(e, type) {
    this.setState({
      [type]: e.target.value
    });
    this.checkDate(e.target.value, type);
  }

  getDate(date) {
    if (moment(date).isValid()) {
      return moment(date).format();
    } else {
      return undefined;
    }
  }

  checkDate(value, type) {
    let { selectDay, selectMonth, selectYear } = this.state;

    if (type === "selectDay") {
      selectDay = value;
    } else if (type === "selectMonth") {
      selectMonth = value;
    } else if (type === "selectYear") {
      selectYear = value;
    }

    if (this.isSelectedAllDropdowns(selectDay, selectMonth, selectYear)) {
      const dateObject = {
        year: selectYear,
        month: selectMonth - 1,
        day: selectDay
      };
      this.props.dateChange(this.getDate(dateObject));
    } else {
      this.props.dateChange(undefined);
    }
  }

  isSelectedAllDropdowns(selectDay, selectMonth, selectYear) {
    if (selectDay === "" || selectMonth === "" || selectYear === "") {
      return false;
    }
    return this.props.mode === "TH"
      ? selectDay !== "วันที่" && selectMonth !== "เดือน" && selectYear !== "ปี"
      : selectDay !== this.props.dayLabel &&
          selectMonth !== this.props.monthLabel &&
          selectYear !== this.props.yearLabel;
  }

  // TODO: Use the isMobile function from /utilities instead
  mobilecheck() {
    let check = false;
    (function(a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }

  render() {
    const { disabled } = this.props;
    const dayElement = this.state.day.map((day, id) => {
      return (
        <option value={day} key={id} style={optionStyle}>
          {day}
        </option>
      );
    });
    const monthElement = this.state.month.map((month, id) => {
      return (
        <option value={month.value} key={id} style={optionStyle}>
          {month.text}
        </option>
      );
    });
    const yearElement = this.state.year.map((year, id) => {
      return (
        <option value={year} key={id} style={optionStyle}>
          {year}
        </option>
      );
    });
    const mobile = this.mobilecheck();
    const { overrideOptionArrows } = this.props;

    return (
      <div className="flex justify-between -mb-3" style={this.props.style}>
        <select
          defaultValue=""
          className={this.props.selectBoxClassName}
          value={this.state.selectMonth}
          onChange={e => this.changeDate(e, "selectMonth")}
          style={{ ...select, ...this.props.selectBoxStyle }}
          disabled={disabled}
        >
          <option value="" style={initialOptionStyle}>
            {this.props.mode === "TH" ? "เดือน" : this.props.monthLabel}
          </option>
          {monthElement}
        </select>
        {mobile && overrideOptionArrows && (
          <OptionArrows
            style={{ position: "relative", right: 27, width: 46 }}
          />
        )}
        <select
          defaultValue=""
          className={this.props.selectBoxClassName}
          value={this.state.selectDay}
          onChange={e => this.changeDate(e, "selectDay")}
          style={{ ...select, ...this.props.selectBoxStyle }}
          disabled={disabled}
        >
          <option value="" style={initialOptionStyle}>
            {this.props.mode === "TH" ? "วันที่" : this.props.dayLabel}
          </option>
          {dayElement}
        </select>
        {mobile && overrideOptionArrows && (
          <OptionArrows
            style={{ position: "relative", right: 27, width: 46 }}
          />
        )}
        <select
          defaultValue=""
          className={this.props.selectBoxClassName}
          value={this.state.selectYear}
          onChange={e => this.changeDate(e, "selectYear")}
          style={{ ...select, ...this.props.selectBoxStyle }}
          disabled={disabled}
        >
          <option value="" style={initialOptionStyle}>
            {this.props.mode === "TH" ? "ปี" : this.props.yearLabel}
          </option>
          {yearElement}
        </select>
        {mobile && overrideOptionArrows && (
          <OptionArrows
            style={{
              position: "relative",
              right: 27,
              marginRight: -27,
              width: 46
            }}
          />
        )}
      </div>
    );
  }
}

DatePicker.propTypes = {
  dateChange: PropTypes.func,
  dayLabel: PropTypes.string,
  defaultDate: PropTypes.string,
  maxYear: PropTypes.number,
  minYear: PropTypes.number,
  mode: PropTypes.string,
  monthLabel: PropTypes.string,
  padDay: PropTypes.bool,
  padMonth: PropTypes.bool,
  selectDay: PropTypes.string,
  selectMonth: PropTypes.string,
  selectYear: PropTypes.string,
  useMonthNames: PropTypes.bool,
  yearLabel: PropTypes.string,
  overrideOptionArrows: PropTypes.bool
};

DatePicker.defaultProps = {
  dayLabel: "Day",
  minYear: 1919,
  maxYear: 2019,
  monthLabel: "Month",
  padDay: false,
  padMonth: false,
  selectDay: "",
  selectMonth: "",
  selectYear: "",
  yearLabel: "Year",
  useMonthNames: false,
  overrideOptionArrows: false
};
